import { render, staticRenderFns } from "./warehouseNewPage.vue?vue&type=template&id=16909edb&scoped=true&"
import script from "./warehouseNewPage.vue?vue&type=script&lang=js&"
export * from "./warehouseNewPage.vue?vue&type=script&lang=js&"
import style0 from "./warehouseNewPage.vue?vue&type=style&index=0&id=16909edb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16909edb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16909edb')) {
      api.createRecord('16909edb', component.options)
    } else {
      api.reload('16909edb', component.options)
    }
    module.hot.accept("./warehouseNewPage.vue?vue&type=template&id=16909edb&scoped=true&", function () {
      api.rerender('16909edb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Warehouse/warehouseNewPage.vue"
export default component.exports